import has from "lodash/fp/has";

export const DEFAULT_LOCALE = "en-GB";

type LocaleMap = Record<string, string>;

export const supportedLocaleMap: LocaleMap = {
	"pt": "pt-BR",
	"pt-BR": "pt-BR",
	"en": "en-GB",
	"en-GB": "en-GB",
	"es": "es-ES",
	"es-ES": "es-ES",
};

export const extractLanguage = (locale?: string | null): string =>
	(locale ?? DEFAULT_LOCALE).split("-")[0];

export const DEFAULT_LANG = extractLanguage(DEFAULT_LOCALE);

export const getSupportedLocale = (preferredLocale: string): string =>
	has(preferredLocale, supportedLocaleMap) ? supportedLocaleMap[preferredLocale] : DEFAULT_LOCALE;
